import {engine} from './liquid_engine';
import JSON5 from 'json5';
import { session, getJWT } from '../Utilities/Session.svelte';

let jwt;

session.subscribe((sess) => {
    if (sess.loggedIn) {
        getJWT().then((res) => {
            jwt = res;
        }).catch(() => {
            jwt = "";
        })
    }
});

function handleRowLoop(worksheet, idx) {
    let new_rows = [];

    let startloop = worksheet.rows[idx].cells[0].text.replace("rowfor", "for");

    let found = false;
    for (idx++; idx < worksheet.rows.len; idx++) {
        let row = worksheet.rows[idx]
        if (row) {
            let firstCell = row?.cells[0]?.text;

            if (firstCell && (firstCell.search(/{%\s*rowfor/) !== -1)) {
                    let [new_idx, tpl] = handleRowLoop(worksheet, idx)
                    new_rows.push(tpl);
                    idx = new_idx
            } else if (firstCell && (firstCell.search(/{%\s*endrowfor\s*%}/) != -1)) {
                found = true;
                break;
            } else {
                new_rows.push(JSON.stringify(row))
            }
        }
    }

    const liquid_template = `[${startloop}\n${new_rows.join(',\n')},\n{% endfor %}]`

    return [idx, liquid_template]
}

function measureTextHeight(cell, style, width) {
    let div = document.createElement('div');
    div.innerText = cell.text;
    div.style.width = `${width}px`;

    if (style.font?.name) {
        div.style.fontFamily = style.font.name
    }

    if (style.font?.size) {
        div.style.size = `${style.font.size}pt`;
    }

    div.style.position = "absolute";
    div.style.left = '-9999px';

    document.body.appendChild(div);
    let divHeight = div.clientHeight;
    document.body.removeChild(div);

    return divHeight;
}

export function auto_size(sheets) {
    for (let sheet of sheets) {
        for (let ri of Object.keys(sheet.rows)) {
            if (ri == "len") continue

            let row = sheet.rows[ri];
            if (row.height) continue

            let wrapHeight = 0;
            for (let ci of Object.keys(row.cells)) {
                let cell = row.cells[ci];
                if (!cell.style) continue

                let style = sheet.styles[cell.style];

                if (style.textwrap) {
                    let cellwidth = sheet.cols[ci]?.width ? sheet.cols[ci].width : 100;

                    let x, y;
                    if (cell.merge) {
                        [y, x] = cell.merge;

                        for (let i = 1; i <= x; i++ ) {
                            cellwidth += sheet.cols[i]?.width ? sheet.cols[i].width : 100;
                        }
                    }

                    let cellHeight = measureTextHeight(cell, style, cellwidth);

                    if (cellHeight > wrapHeight) {
                        wrapHeight = cellHeight;
                    }
                }
            }

            if (wrapHeight) {
                row.height = wrapHeight;
            }
        }
    }

    return sheets;
}

export function updateMerges(sheets) {
    for (let sheet of sheets) {
        sheet.merges = [];

        for (let ri of Object.keys(sheet.rows)) {
            if (ri == "len") continue
            let row = sheet.rows[ri];

            for (let ci of Object.keys(row.cells)) {
                let cell = row.cells[ci];

                if (!cell.merge) continue;

                // get merge cell reference
                let start_cell = String.fromCharCode(parseInt(ci) + 65);
                let start_row = parseInt(ri) + 1;

                let end_cell = String.fromCharCode(parseInt(ci) + cell.merge[1] + 65)
                let end_row = 1 + parseInt(ri) + cell.merge[0];

                sheet.merges.push(`${start_cell}${start_row}:${end_cell}${end_row}`);
            }
        }
    }

    return sheets;
}

function getDataUrl(obj, height, width) {
    return new Promise((resolve, reject) => {

        function blobToImage(blob) {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            }
            reader.readAsDataURL(blob);
        }

        if (typeof obj === "string") {
            if (obj.startsWith("data:image")) {
                let img = new Image();

                if (height) {
                    img.style.height = `${height}px`;
                }

                if (width) {
                    img.style.width = `${width}px`;
                }

                img.onload = () => {
                    // add the child to the page so that we properly calculate image size
                    // necessary for SVG
                    img.style.position = "absolute";
                    img.style.left = "-99999px";
                    document.body.appendChild(img);

                    const canvas = document.createElement("canvas");
                    canvas.height = img.height;
                    canvas.width = img.width;

                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, img.width, img.height);

                    document.body.removeChild(img);
                    resolve(canvas.toDataURL("image/png"));
                }
                img.src = obj;
            } else if (obj.startsWith('http')) {
                fetch('/generate/relay/', {
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${jwt}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        url: obj
                    })
                }).then((response) => {
                    response.blob().then(blob => {
                        blobToImage(blob);
                    })
                })
            } else {
                try {
                    blobToImage(obj)
                } catch (e) {
                    reject(e);
                }
            }
        }

    })
}


export async function generateExcelTemplate(template, assessment) {

    let new_template = JSON.parse(JSON.stringify(template));
        let tpl = JSON.parse(JSON.stringify(template))
        for (let sheet_idx = 0; sheet_idx < tpl.length; sheet_idx++) {
            const tpl_worksheet = tpl[sheet_idx];
            let worksheet = new_template[sheet_idx];

            worksheet.rows = {};

            if (tpl_worksheet.rows.len) {
                worksheet.rows.len = tpl_worksheet.rows.len;
            }

            let write_idx = 0;
            for (let row_idx = 0; row_idx < tpl_worksheet.rows.len; row_idx++) {
                let row = tpl_worksheet.rows[row_idx]
                if (row) {
                    let firstCell = row?.cells[0]?.text;

                    if (firstCell && (firstCell.search(/{%\s*rowfor/) !== -1)) {
                        let [new_idx, new_row_template] = handleRowLoop(tpl_worksheet, row_idx);

                        row_idx = new_idx;

                        let template_rows = await engine.parseAndRender(new_row_template, assessment);
                        try {
                            const new_rows = JSON5.parse(template_rows)
                            for (let row of new_rows) {
                                worksheet.rows[write_idx] = row;
                                write_idx++;
                            }
                        } catch (e) {
                            console.log(e);
                            console.log(template_rows)
                            throw e;
                        }

                        continue
                    } else {
                        // check for template images
                        for (let col of Object.values(row.cells)) {
                            if (col?.image?.template) {
                                col.image.data = await engine.parseAndRender(col.image.template, assessment)

                                if (col.image.data.startsWith('http')) {
                                    col.image.data = await getDataUrl(col.image.data, col.image.height, col.image.width);
                                }

                                delete col.image.template;
                            }
                        }
                    }

                    worksheet.rows[write_idx] = row;
                }
                write_idx++
            }
        }

        var rendered = await engine.parseAndRender(JSON.stringify(new_template), assessment);

    return rendered;
}

export async function generate_report(orig_assessment) {
    // make a copy of the assessment so we don't change it by accident
    // copy model
    let assessment_model = orig_assessment.model;
    orig_assessment.model = undefined

    let assessment = JSON.parse(JSON.stringify(orig_assessment));

    orig_assessment.model = assessment_model

    // generate slides
    let promises = [];
    let slide_no = 1;
    for (let s of assessment.assessment_type_data.report_slides) {
        if (!assessment.slides[s.slide_id] || assessment.slides[s.slide_id].reset) {
            promises.push(
                Promise.all([
                    engine.parseAndRender(s.body, {...assessment, slide_number: slide_no}),
                    engine.parseAndRender(s.css, {...assessment, slide_number: slide_no})
                ]).then(([rendered_html, rendered_css]) => {
                    let custom_slide = assessment.slides[s.slide_id] || {};

                    custom_slide.slide_id = s.slide_id;
                    custom_slide.css = rendered_css;
                    custom_slide.body = rendered_html;
                    custom_slide.reset = true; // don't save non-customized slides

                    assessment.slides[s.slide_id] = custom_slide;
                })
            );
        }
        slide_no++;
    }

    // generate excel
    if (assessment.assessment_type_data.excel_template) {
        assessment.excel = JSON.parse(await generateExcelTemplate(assessment.assessment_type_data.excel_template.template, assessment));
    }

    await Promise.all(promises);


    let res = await fetch('/generate/new/', {
        method: "POST",
        body: JSON.stringify(assessment),
        headers: {
            'Authorization': `Bearer ${jwt}`,
            "content-type": "application/json"
        }
    });


    if (res.status != 200) {
        notifier.danger(res.statusText);
        report_generating = false;
    } else {

        let current_datetime = new Date()
        let formatted_date = "_" + current_datetime.getFullYear() + "_" + (current_datetime.getMonth() + 1) + "_" + current_datetime.getDate();

        try {
            let blob = await res.blob()
            let url = URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.href = url;
            link.download = assessment.details['name'] + "_report_" + formatted_date + ".zip";
            link.target = "_new";

            link.click();

            URL.revokeObjectURL(url);
        } catch(e) {
            notifier.danger(e);
        };
    }
}